<script lang="ts">
	import Sizer from './Sizer.svelte'
	import type { FileField } from 'datocms/models'
	import { onMount } from 'svelte'
	import { run } from 'svelte/legacy'

	interface Props {
		image: FileField
		imageMobile?: FileField
		lazy?: boolean
		class?: string
	}

	let { image, imageMobile, lazy = true, class: className = '' }: Props = $props()

	let placeholder = $state(false)

	let imgElement: HTMLImageElement = $state(null)

	function setPlaceholderVisibility(complete: boolean) {
		if (complete !== undefined) {
			placeholder = !complete
		}
	}

	run(() => {
		setPlaceholderVisibility(imgElement?.complete)
	})

	onMount(() => setPlaceholderVisibility(imgElement?.complete))
</script>

{#if image?.responsiveImage}
	<div
		style="aspect-ratio: {image.responsiveImage.aspectRatio}; {placeholder
			? `background-image: url(${image.responsiveImage.base64})`
			: ''}"
		class="relative max-h-full max-w-full bg-cover {className}"
	>
		<div class={imageMobile?.responsiveImage ? 'max-md:hidden' : ''}>
			<Sizer
				aspectRatio={image.responsiveImage.aspectRatio}
				height={image.height}
				width={image.width}
			/>
		</div>
		{#if imageMobile?.responsiveImage}
			<div class="md:hidden">
				<Sizer
					aspectRatio={imageMobile.responsiveImage.aspectRatio}
					height={imageMobile.height}
					width={imageMobile.width}
				/>
			</div>
		{/if}
		<picture class="absolute inset-0">
			{#if imageMobile?.responsiveImage}
				<source
					media="(max-width: 767px)"
					srcset={imageMobile.responsiveImage.webpSrcSet}
					type="image/webp"
				/>
				<source media="(max-width: 767px)" srcset={imageMobile.responsiveImage.srcSet} />
			{/if}
			<source srcset={image.responsiveImage.webpSrcSet} type="image/webp" />
			<source srcset={image.responsiveImage.srcSet} />
			<img
				bind:this={imgElement}
				alt={image.responsiveImage.alt}
				fetchpriority={lazy ? null : 'high'}
				height={image.height}
				loading={lazy ? 'lazy' : null}
				onload={() => (placeholder = false)}
				src={image.responsiveImage.src}
				title={image.responsiveImage.title}
				width={image.width}
			/>
		</picture>
	</div>
{:else if image?.format === 'svg'}
	<div class="relative {className}">
		<picture>
			{#if imageMobile?.format === 'svg'}
				<source media="(max-width: 767px)" srcset={imageMobile.url} />
			{/if}
			<img
				alt={image.alt}
				height={image.height}
				loading={lazy ? 'lazy' : null}
				src={image.url}
				width={image.width}
			/>
		</picture>
	</div>
{/if}
